module.exports = __webpack_public_path__ + "img/empty_stage.d7053b31.svg";